"use strict";
export var SharedEventName = /* @__PURE__ */ ((SharedEventName2) => {
  SharedEventName2["ANALYTICS_SWITCH_TOGGLED"] = "Analytics Switch Toggled";
  SharedEventName2["APP_LOADED"] = "Application Loaded";
  SharedEventName2["ELEMENT_CLICKED"] = "Element Clicked";
  SharedEventName2["FOOTER_CLICKED"] = "Footer Clicked";
  SharedEventName2["HEARTBEAT"] = "Heartbeat";
  SharedEventName2["MENU_CLICKED"] = "Menu Clicked";
  SharedEventName2["NAVBAR_CLICKED"] = "Navbar Clicked";
  SharedEventName2["PAGE_CLICKED"] = "Page Clicked";
  SharedEventName2["PAGE_VIEWED"] = "Page Viewed";
  SharedEventName2["SEARCH_BAR_CLICKED"] = "Search Bar Clicked";
  SharedEventName2["SENTIMENT_SUBMITTED"] = "Sentiment Submitted";
  SharedEventName2["TERMS_OF_SERVICE_ACCEPTED"] = "Terms of Service Accepted";
  SharedEventName2["WEB_VITALS"] = "Web Vitals";
  return SharedEventName2;
})(SharedEventName || {});
export var BrowserEvent = /* @__PURE__ */ ((BrowserEvent2) => {
  BrowserEvent2["onClick"] = "onClick";
  BrowserEvent2["onFocus"] = "onFocus";
  BrowserEvent2["onKeyPress"] = "onKeyPress";
  BrowserEvent2["onSelect"] = "onSelect";
  return BrowserEvent2;
})(BrowserEvent || {});
export var Browser = /* @__PURE__ */ ((Browser2) => {
  Browser2["BRAVE"] = "Brave";
  Browser2["CHROME"] = "Google Chrome or Chromium";
  Browser2["EDGE"] = "Microsoft Edge (Legacy)";
  Browser2["EDGE_CHROMIUM"] = "Microsoft Edge (Chromium)";
  Browser2["FIREFOX"] = "Mozilla Firefox";
  Browser2["INTERNET_EXPLORER"] = "Microsoft Internet Explorer";
  Browser2["OPERA"] = "Opera";
  Browser2["SAFARI"] = "Apple Safari";
  Browser2["SAMSUNG"] = "Samsung Internet";
  Browser2["UNKNOWN"] = "unknown";
  return Browser2;
})(Browser || {});
export function getBrowser() {
  const sUsrAg = navigator.userAgent;
  if (sUsrAg.indexOf("Firefox") > -1) {
    return "Mozilla Firefox" /* FIREFOX */;
  } else if (sUsrAg.indexOf("SamsungBrowser") > -1) {
    return "Samsung Internet" /* SAMSUNG */;
  } else if (sUsrAg.indexOf("Opera") > -1 || sUsrAg.indexOf("OPR") > -1) {
    return "Opera" /* OPERA */;
  } else if (sUsrAg.indexOf("Trident") > -1) {
    return "Microsoft Internet Explorer" /* INTERNET_EXPLORER */;
  } else if (sUsrAg.indexOf("Brave") > -1) {
    return "Brave" /* BRAVE */;
  } else if (sUsrAg.indexOf("Edge") > -1) {
    return "Microsoft Edge (Legacy)" /* EDGE */;
  } else if (sUsrAg.indexOf("Edg") > -1) {
    return "Microsoft Edge (Chromium)" /* EDGE_CHROMIUM */;
  } else if (sUsrAg.indexOf("Chrome") > -1) {
    return "Google Chrome or Chromium" /* CHROME */;
  } else if (sUsrAg.indexOf("Safari") > -1) {
    return "Apple Safari" /* SAFARI */;
  } else {
    return "unknown" /* UNKNOWN */;
  }
}
export var CustomUserProperties = /* @__PURE__ */ ((CustomUserProperties2) => {
  CustomUserProperties2["ALL_WALLET_ADDRESSES_CONNECTED"] = "all_wallet_addresses_connected";
  CustomUserProperties2["ALL_WALLET_CHAIN_IDS"] = "all_wallet_chain_ids";
  CustomUserProperties2["BROWSER"] = "browser";
  CustomUserProperties2["CHAIN_ID"] = "chain_id";
  CustomUserProperties2["DARK_MODE"] = "is_dark_mode";
  CustomUserProperties2["EXPERT_MODE"] = "is_expert_mode";
  CustomUserProperties2["GIT_COMMIT_HASH"] = "git_commit_hash";
  CustomUserProperties2["PEER_WALLET_AGENT"] = "peer_wallet_agent";
  CustomUserProperties2["ROUTER_PREFERENCE"] = "router_preference";
  CustomUserProperties2["SCREEN_RESOLUTION_HEIGHT"] = "screen_resolution_height";
  CustomUserProperties2["SCREEN_RESOLUTION_WIDTH"] = "screen_resolution_width";
  CustomUserProperties2["TESTNET_MODE_ENABLED"] = "testnet_mode_enabled";
  CustomUserProperties2["USER_AGENT"] = "user_agent";
  CustomUserProperties2["WALLET_ADDRESS"] = "wallet_address";
  CustomUserProperties2["WALLET_NAME"] = "wallet_name";
  CustomUserProperties2["WALLET_TYPE"] = "wallet_type";
  CustomUserProperties2["WALLET_VERSION"] = "wallet_version";
  return CustomUserProperties2;
})(CustomUserProperties || {});
